<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header-small signup-page section-image">
          <!-- v-bind:style="{ 'background-image' : 'url(' +  blogs.picture + ')' }" -->
            <parallax class="page-header-image" v-bind:style="{ 'background-image' : 'url(' +  picture + ')' }" >
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">{{type}}</h2>
                        <h5>Predictions</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section">
                    <!-- <h3 class="title text-center">You may also be interested in</h3> -->
                    <br/>

                <div class="row">
                    <div class="col-md-8">

                    <div class="row">
                        <!-- <div v-for='blog in queriedData' :key="blog.id" class="col-md-12"> -->
                        <card v-for='blog in queriedData' :key="blog.id" class="col-md-12" type="blog" plain>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" :src="blog.picture" />
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                      <router-link v-bind:to="{name: 'Prediction-Detail', params: { item_id: blog.id }}">
                                      {{blog.title}}
                                    </router-link>
                                    </h3>
                                    <p class="card-description">
                                       {{blog.content}}
                                    </p>
                                </div>
                            </div>
                        </card>
                        <!-- </div> -->
                    </div>
                    <!-- v-model="pagination.full"
                    :total="total" -->
                    <div class="pagination-container justify-content-center">
                        <n-pagination type="primary"
                                      prev-item-classes="arrow-margin-left"
                                      next-item-classes="arrow-margin-right"
                                      v-model="pagination.currentPage"
                                      :per-page="pagination.perPage"
                                      :total="total"
                                      >

                        </n-pagination>
                    </div>

                    </div>
                   <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Pagination } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import db from '../../components/Firebase/firebaseInit'
  import Sidebar from '@/pages/bet/sidebar';
  import firebase from 'firebase';


  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Sidebar,
      Card,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Pagination.name]: Pagination,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.blogs;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.blogs.length;
    },
  },
    data() {
      return {
        year: new Date().getFullYear(),
        blogs: [],
        sports_id: null,
        picture: null,
        searchedData: [],
        type: null,
        pagination: {
          full: 1
        },
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
      }
    },
    beforeRouteEnter(to, from, next) {
    db.collection('predictions').orderBy('time', 'desc').where('type', '==', to.params.sports_id).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {
              const data = {
                'id': doc.id,
                'title': doc.data().title,
                'content': doc.data().content,
                'picture': doc.data().picture
                }
                vm.blogs.push(data);
                vm.type = doc.data().type;

          });
        });
      });
    db.collection('sports').where('name', '==', to.params.sports_id).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {
                vm.picture = doc.data().picture;

          });
        });
      });

  },
   watch: {
    $route: 'fetchData'
  },
    methods: {
        
    fetchData () {
      this.blogs = [];
      this.type = null;
      db.collection('predictions')
        .orderBy('time', 'desc')
        .where('type', '==', this.$route.params.sports_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
                this.blogs.push({
                'id': doc.id,
                'title': doc.data().title,
                'content': doc.data().content,
                'picture': doc.data().picture
                });
                this.type = doc.data().type;
          });
        });
      this.picture = null;
      db.collection('sports')
        .where('name', '==', this.$route.params.sports_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
              this.picture = doc.data().picture;
          });
        });

    },

    }

  }
</script>
<style>
</style>
